<script>
import Moment from 'moment-timezone';
import _ from 'lodash';
import { extendMoment } from 'moment-range';
import EventBus from '../EventBus.js';
import Spinner from './Spinner.vue';

const moment = extendMoment(Moment);
moment.tz.setDefault("America/Los_Angeles");
export default {
  components: { Spinner },
  props: ['inputStartTime'],
  data: function() {
    var startTime = this.getStartTime();
    return {
      events: [],
      startTime: startTime.result,
      endTime: this.getEndTime(startTime.result),
      selectedIndex: [],
      moveRightCount: startTime.moveRightCount,
      loading: false,
      selectedDate: moment(this.inputStartTime),
    }
  },
  methods: {
    getInitialSelectedIndex() {
      if (this.inputStartTime) {
        var selected = moment(this.inputStartTime);
        var start = moment(this.inputStartTime).set('hour', 15).set('minute', 0).set('second', 0);
        var duration = moment.duration(selected.diff(start));
        var minutes = duration.asMinutes();
        return [_.findIndex(this.daysList, (day) => { return selected.isSame(day.object, 'day') }), minutes / 30];
      } else {
        return []
      }
    },
    loadEvent: function() {
      this.loading = true;
      return this.$getGoogleCalendarEvents(
        this.startTime.format(),
        moment(this.endTime).add(2, 'h').add(30, 'minutes').format(),
        this.assignEvents
      );
    },
    assignEvents: function(data) {
      this.events = _.map(data.items, function(item) {
        var start = moment(item.start.dateTime);
        var end = moment(item.end.dateTime);
        var range = moment.range(start, end);
        return { start, end, range };
      });
    },
    getInitialStartTime() {
      var ThursdayIndex = 4;
      var TuesdayIndex = 2;
      var today = moment();
      var todayIndex = today.isoWeekday();
      var result;
      if (todayIndex >= ThursdayIndex) {
        result = today.isoWeekday(TuesdayIndex).add(7, 'd');
      } else if(todayIndex < ThursdayIndex && todayIndex >= TuesdayIndex) {
        result = today.isoWeekday(ThursdayIndex);
      } else {
        result = today.isoWeekday(TuesdayIndex);
      }

      return result.set('hour', 15).set('minute', 0).set('second', 0);
    },

    getStartTime() {
      var start = this.getInitialStartTime();
      if (!this.inputStartTime) {
        return { result: start, moveRightCount: 0 };
      }
      var TuesdayIndex = 2;
      // 3pm of nearest Tuesday or Thurday to today
      var end = this.getEndTime(start);
      var range = moment.range(start.set('hour', 1), end.set('hour', 23));
      var target = moment(this.inputStartTime);
      var exit = range.contains(target);
      var moveRightCount = 0;
      while (!exit) {
        moveRightCount = moveRightCount + 1;
        var dayIndex = start.isoWeekday();
        if (dayIndex == TuesdayIndex) {
          start.add(23, 'd')
        } else {
          start.add(26, 'd')
        }
        end = this.getEndTime(start);
        range = moment.range(start.set('hour', 1), end.set('hour', 23));
        exit = range.contains(target);
      }
      return { result: start, moveRightCount };
    },
    getEndTime(startTime) {
      var start = moment(startTime)
      return start.add(21, 'd');
    },
    timeClass(index, day) {
      var klass = ['slot', 'text-center'];
      day.busySlots.indexOf(index) == -1 ? klass.push('active') : klass.push('busy')
      var sameSelectedDate = this.selectedDate && this.selectedDate.isSame(day.object, 'day');
      if (this.selectedIndex[0] == this.daysList.indexOf(day) && this.selectedIndex[1] == index && sameSelectedDate) klass.push('selected')
      return klass;
    },
    moveLeft: function() {
      if (!this.canMoveLeft || this.loading) return;
      var currentStartDay = this.startTime.isoWeekday();
      if (currentStartDay == 2) {
        this.startTime = moment(this.startTime.subtract(26, 'd'))
      } else {
        this.startTime = moment(this.startTime.subtract(23, 'd'))
      }
      this.endTime = this.getEndTime(this.startTime);
      this.loadEvent();
      this.moveRightCount = this.moveRightCount - 1;
    },
    moveRight: function() {
      if (this.loading) return;
      var currentStartDay = this.startTime.isoWeekday();
      if (currentStartDay == 2) {
        this.startTime = moment(this.startTime.add(23, 'd'))
      } else {
        this.startTime = moment(this.startTime.add(26, 'd'))
      }
      this.endTime = this.getEndTime(this.startTime);
      this.loadEvent();
      this.moveRightCount = this.moveRightCount + 1;
    },
    onTimeSelect(day, slotIndex) {
      if(day.busySlots.indexOf(slotIndex) > -1) return
      this.$emit('time-select', moment(day.object).add(slotIndex * 30, 'minutes'));
      this.selectedIndex = [this.daysList.indexOf(day), slotIndex];
      this.selectedDate = day.object;
    },
    resetSlectedTime() {
      this.$emit('time-select', null);
      this.selectedIndex = [];
    },
    stopLoading() {
      this.loading = false
    },
  },
  computed: {
    daysList: function() {
      var theDate = moment(this.startTime);
      var count = 0;
      var days = [];
      //  we only display 7 days
      while (count < 7) {
        // loop through events to check busy slots
        var busySlots = [];
        _.each(this.events, function(event) {
          var range1 = moment.range(theDate, moment(theDate).add(29, 'minutes'));
          var range2 = moment.range(moment(theDate).add(30, 'minutes'), moment(theDate).add(59, 'minutes'));
          var range3 = moment.range(moment(theDate).add(60, 'minutes'), moment(theDate).add(89, 'minutes'));
          var range4 = moment.range(moment(theDate).add(90, 'minutes'), moment(theDate).add(119, 'minutes'));
          if (event.range.overlaps(range1)) {
            busySlots.push(0);
          }
          if (event.range.overlaps(range2)) {
            busySlots.push(1);
          }
          if (event.range.overlaps(range3)) {
            busySlots.push(2);
          }
          if (event.range.overlaps(range4)) {
            busySlots.push(3);
          }
        });

        days.push({ object: moment(theDate), busySlots });

        count = count + 1;
        if (theDate.isoWeekday() == 2) {
          theDate.add(2, 'd');
        } else {
          theDate.add(5, 'd')
        }
      }

      return days;
    },
    canMoveLeft: function() {
      return this.moveRightCount > 0;
    }
  },
  mounted() {
    this.loadEvent();
    this.selectedIndex = this.getInitialSelectedIndex();
  },
  created() {
    let meta1 = document.createElement('meta')
    meta1.setAttribute('property', "google:api_key")
    meta1.setAttribute('content', process.env.VUE_APP_GOOGLE_API_KEY)
    document.head.appendChild(meta1)

    let meta2 = document.createElement('meta')
    meta2.setAttribute('property', "google:client_id")
    meta2.setAttribute('content', process.env.VUE_APP_GOOGLE_CLIENT_ID)
    document.head.appendChild(meta2)

    let script = document.createElement('script')
    script.setAttribute('src', "https://apis.google.com/js/api.js")
    document.head.appendChild(script)

    let initScript = document.createElement('script')
    initScript.innerHTML = `
      function start() {
        // Initializes the client with the API key and the Translate API.
        var apiKey = document.querySelector('[property="google:api_key"]').content;
        var clientId = document.querySelector('[property="google:client_id"]').content;
        gapi.client.init({
          'apiKey': apiKey,
          'clientId': clientId,
          discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"],
          'scope': "https://www.googleapis.com/auth/calendar"
        }).then(function() {
          return gapi.client.language.translations.list({
            q: 'hello world',
            source: 'en',
            target: 'de',
          });
        }).then(function(response) {
          console.log(response);
        }, function(reason) {
          console.log(reason)
        });
      };

      function waitUntilGapiURLIsLoaded() {
        if(window.gapi) {
          gapi.load('client', start)
        } else {
          setTimeout(waitUntilGapiURLIsLoaded, 1000);
        }
      }

      waitUntilGapiURLIsLoaded();

    `;
    document.head.appendChild(initScript)
    EventBus.$on('google-api-finish-loading', this.stopLoading)
  },
  beforeDestroy() {
    EventBus.$off('google-api-finish-loading', this.stopLoading)
  }
}

</script>

<template>
  <div class="calendar-container">
    <div class="flex-box">
      <div class='controller'>
        <div class="gap-3x"></div>
        <div
          :class="[canMoveLeft ? '' : 'inactive']"
          @click="moveLeft"
        ><font-awesome-icon icon="chevron-left" /></div>
      </div>
      <div class="spinner-container flex-box" v-if="loading"><Spinner /></div>
      <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
      <div v-for="day in daysList" :key="day.object.format()" class="day" v-if="!loading">
        <div class="gap-3x"></div>
        <div class="bold text-center day-label">{{day.object.format('dddd')}}</div>
        <div class="bold text-center day-label">{{day.object.format('MMMM D')}}</div>
        <div class="gap-3x"></div>
        <div :class="timeClass(0, day)" @click="() => onTimeSelect(day, 0)">3:00 PM</div>
        <div :class="timeClass(1, day)" @click="() => onTimeSelect(day, 1)">3:30 PM</div>
        <div :class="timeClass(2, day)" @click="() => onTimeSelect(day, 2)">4:00 PM</div>
        <div :class="timeClass(3, day)" @click="() => onTimeSelect(day, 3)">4:30 PM</div>
      </div>
      <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
      <div class="controller">
        <div class="gap-3x"></div>
        <div
          @click="moveRight"
        ><font-awesome-icon icon="chevron-right" /></div>
      </div>
    </div>
  </div>
</template>

<style lang='scss'>
  .calendar-container {
    max-width: 1200px;
    margin: auto;
    height: 288px;
  }

  .day {
    min-width: 132px;
    max-width: 132px;
  }

  .day-label {
    min-width: 108px;
    max-width: 115px;
    margin: auto;
  }

  .slot.busy {
    color: #DDDDDD;
    cursor: not-allowed;
  }

  .slot.active {
    color: #6D6D6D;
    cursor: pointer;
  }

  .slot.selected {
    color: white;
    border-radius: 24px;
    background: #6D6D6D;
  }

  .slot {
    height: 48px;
    line-height: 48px;
  }

  .controller {
    height: 48px;
    line-height: 48px;
    width: calc(50% - 448px);
    text-align: center;
  }

  .controller path  {
    color: #6D6D6D;
  }

  .controller .inactive path  {
    color: #DDDDDD;
  }

  .spinner-container {
    width: 924px;
    justify-content: center;
    align-items: center;
  }

  @media screen and (max-width: 1024px) {
    .calendar-container .controller  {
      margin: 0;
    }
  }
</style>
